<template>
  <section
    class="lvo"
    data-wptv="lvo-section">
    <h4
      class="m-0 title"
      data-wptv="lvo-section-titre">
      {{ lvoSection.title }}
    </h4>
    <div class="icon-section">
      <div class="icon">
        <span
          class="icon icon-vod-portrait"
          aria-hidden="true" />
      </div>
      <span class="text icon-description">
        {{ lvoSection.iconDescription }}
      </span>
    </div>
    <div class="text description">
      {{ lvoSection.description }}
    </div>
    <div class="buttons">
      <wptv-button
        v-tealium:click="createStats('mlv-telecharger', download)"
        class="download"
        :aria-label="lvoSection.buttons.download.ariaLabel"
        data-wptv="lvo-section-btn-téléchargement"
        type="full"
        background="black"
        tabindex="0"
        @click.native="downloadClick()">
        {{ lvoSection.buttons.download.label }}
      </wptv-button>
      <a
        v-tealium:click="createStats('mlv-en_savoir_plus', more)"
        :href="more"
        target="_blank"
        :aria-label="lvoSection.buttons.more.ariaLabel"
        class="o-link-arrow o-link-reverse more"
        data-wptv="lvo-section-btn-en-savoir-plus">
        {{ lvoSection.buttons.more.label }}
      </a>
    </div>
  </section>
</template>

<script>
import { WptvButton } from '../../button'
import _get from 'lodash/get'

export default {
  name: 'LvoSection',
  components: {
    WptvButton
  },
  props: {
    lvoSection: {
      type: Object,
      required: true
    },
    usedOS: {
      type: String,
      required: true
    }
  },
  computed: {
    download () {
      return _get(this.$config, this.lvoSection.buttons.download[`linkRef${this.usedOS === 'Mac OS' ? 'Mac' : 'Win'}`], '')
    },
    more () {
      return _get(this.$config, this.lvoSection.buttons.more.linkRef, '')
    }
  },
  methods: {
    downloadClick () {
      location = this.download
    },
    createStats (name, cible) {
      return {
        track_page: 'home',
        track_zone: 'footer',
        track_nom: name,
        track_cible: cible,
        track_type: 'clic'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/abstracts/variables';
@import '../../../scss/abstracts/mixins';

.lvo {
  display: flex;
  flex-direction: column;
  min-width: 370px;
  @include mediaQueries('padding-right', (medium: 30px, large: 0));

  .title {
    padding-bottom: 18px;
  }

  .text {
    font-size: 16px;
    @include mediaQueries('font-size', (large: 18px));
    line-height: 20px;
    @include mediaQueries('line-height', (large: 24px));
  }

  .icon-section {
    display: flex;
    align-items: center;
    padding-bottom: 22px;

    .icon {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: $primary;
      width: 70px;
      height: 70px;
      font-size: 42px;
      border-radius: 20%;
    }

    .icon-description {
      padding-left: 30px;
      font-size: 16px;
      @include mediaQueries('font-size', (large: 18px));
      line-height: 24px;
    }
  }

  .description {
    padding-bottom: 25px;
  }

  .buttons {
    display: flex;
    flex-direction: column;
    @include mediaQueries('flex-direction', (medium: row));
    align-items: baseline;

    button {
      white-space: nowrap;
      max-width: none;
    }

    .download {
      margin: 0 0 15px 0;
      @include mediaQueries('margin', (medium: 0 30px 0 0));
    }
  }
}
</style>
